import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import './styles/element-variables.scss';
import { filterXSS, cleanRichText } from '@/common/xss';
import VueAMap from '@vuemap/vue-amap';
import '@vuemap/vue-amap/dist/style.css';
import Pagination from "./components/pagination/index.vue";
import GuideBtn from "./components/guideBtn.vue";
import { download } from './utils/download'
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';

VueAMap.initAMapApiLoader({
  key: 'c587965e0b5d816359e56e851325054b',
  securityJsCode: '4e6cf7419cf2e0a1021e1ed6c0fac6b2',
  plugins: [
    'AMap.MouseTool',
    'AMap.moveAnimation',
    'AMap.Autocomplete', // 输入提示插件
    'AMap.PlaceSearch', // POI搜索插件
    'AMap.Scale', // 右下角缩略图插件 比例尺
    'AMap.OverView', // 地图鹰眼插件
    'AMap.ToolBar', // 地图工具条
    'AMap.MapType', // 类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
    'AMap.PolyEditor', // 编辑 折线多，边形
    'AMap.CircleEditor', // 圆形编辑器插件
    'AMap.Geolocation', // 定位控件，用来获取和展示用户主机所在的经纬度位置
  ],
  v: '1.4.4', //版本号
  pName: 'Geocoder',
});

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueAMap);
Vue.component('Pagination', Pagination)
Vue.component('GuideBtn', GuideBtn)

Vue.prototype.download = download;
Vue.prototype.$driver = driver;
const safeHtml = function (el, binding) {
  const res = filterXSS(binding.value);
  el.innerHTML = res;
};

const plainText = function (el, binding) {
  const text = cleanRichText(binding.value);
  el.innerText = text;
};

Vue.directive('safe-html', {
  inserted: safeHtml,
  componentUpdated: safeHtml,
});

Vue.directive('plain-text', {
  inserted: plainText,
  componentUpdated: plainText,
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
